import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

import styles from "../statistics.module.css";
import { customTooltipHandler } from "..";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

export function Average3MonthsVolume({ threeMonthsVolumeAvg }) {
  const total = threeMonthsVolumeAvg?.total;
  const centerTextPlugin = {
    id: "centerText",
    afterDraw(chart, args, options) {
      const { ctx, chartArea } = chart;
      const { width, height } = chartArea;

      const total = options.total;
      if (!total) return;

      ctx.save();
      ctx.font = "bold 28px Arial";
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(total, width / 2, height / 2);
      ctx.restore();
    },
  };

  const labels = ["Above_10m", "Between_1m_10m", "Below_1m"];
  const dataValues = [
    threeMonthsVolumeAvg?.above_10m?.percent,
    threeMonthsVolumeAvg?.between_1m_10m?.percent,
    threeMonthsVolumeAvg?.below_1m?.percent,
  ];
  const valueValues = [
    threeMonthsVolumeAvg?.above_10m?.value,
    threeMonthsVolumeAvg?.between_1m_10m?.value,
    threeMonthsVolumeAvg?.below_1m?.value,
  ];
  const MIN_VALUE = 0.5;

  const normalizedData = dataValues.map((v) =>
    v < MIN_VALUE && v > 0 ? MIN_VALUE : v,
  );
  const data = {
    labels,
    datasets: [
      {
        label: "Average 3 Months Volume",
        data: normalizedData,
        backgroundColor: ["#236192", "#418FDE", "#34B3F1"],
        borderColor: "#fff",
        borderWidth: 2,
        hoverOffset: 4,
        borderRadius: 6,
        minAngle: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "70%",
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          color: "#374151",
          font: { size: 14 },
        },
      },
      tooltip: {
        enabled: false,
        external: (context) => {
          const index = context.tooltip?.dataPoints?.[0]?.dataIndex;
          if (index === undefined) return;

          let value = valueValues[index] + "";
          value = value.slice(0, 3);
          customTooltipHandler(context, value);
        },
      },
      title: {
        display: false,
      },
      centerText: {
        total: new Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short",
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(total),
      },
    },
  };

  const slicePercentPlugin = {
    id: "slicePercent",
    afterDraw(chart) {
      const { ctx, data } = chart;
      const dataset = data.datasets[0];
      const total = dataset.data.reduce((acc, val) => acc + val, 0);

      ctx.save();
      ctx.font = "500 14px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const meta = chart.getDatasetMeta(0);

      meta.data.forEach((arc, index) => {
        const rawValue = dataset.data[index];
        if (!rawValue) return;

        const percent = total ? (rawValue / total) * 100 : 0;

        const percentText = `${percent.toFixed(0)}%`;

        const angle = (arc.startAngle + arc.endAngle) / 2;

        const baseRadius = (arc.outerRadius + arc.innerRadius) / 2;

        let radius = baseRadius;

        if (percent > 1) {
          radius = baseRadius;
          ctx.fillStyle = "#ffffff";
        } else {
          radius = baseRadius + 38;
        }

        const x = arc.x + radius * Math.cos(angle);
        const y = arc.y + radius * Math.sin(angle);

        ctx.fillText(percentText, x, y);
      });

      ctx.restore();
    },
  };

  return (
    <div className={styles.statisticsContent} style={{ margin: "20px auto" }}>
      <h2 className={styles.statisticsTitle} style={{ marginLeft: "70px" }}>
        Average 3 Months Volume
      </h2>
      <div
        className={styles.statisticsColoredBar}
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          width: "850px",
          marginTop: "50px",
        }}
      >
        <div
          className={styles.statisticTableWrapper}
          style={{
            marginTop: "35px",
            height: "300px",
            width: "450px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className={styles.statisticTableOneColumn}
            style={{
              width: "60%",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                background: "transparent",
                width: "135px",
                height: "135px",
                borderRadius: "135px",
                top: "67px",
                left: "67px",
                boxShadow: "0px 4.09px 19.11px 0px #00000029",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                background: "transparent",
                width: "155px",
                height: "155px",
                borderRadius: "155px",
                top: "57px",
                left: "57px",
                border: "1px dashed #8D8D8D",
              }}
            ></div>
            <Doughnut
              data={data}
              options={options}
              plugins={[centerTextPlugin, slicePercentPlugin]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
